import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
// import './styles/styles.css';
import 'draft-js/dist/Draft.css';
import 'draftail/dist/draftail.css';
import '@fontsource/commissioner/300.css';
import '@fontsource/commissioner/400.css';
import '@fontsource/commissioner/500.css';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './styles/theme';
import App from './App';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/+$/, '');
if (apiBaseUrl) {
	axios.defaults.baseURL = apiBaseUrl;
}

ReactDOM.render(
	<React.StrictMode>
		<ChakraProvider theme={theme}>
			<App />
		</ChakraProvider>
	</React.StrictMode>,
	document.getElementById('root')
);
